import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const pageData: Record<string, {
  title: string;
  text: React.ReactNode;
  param: string;
}> = {
  '1': {
    title: 'Privacy Statement',
    param: 'privacy',
    text: <div className="space-y-3 text-sm text-slate-800 leading-relaxed" data-id="element-2710" data-mp="32fsyq7w8jofw">
        <p className="text-red-600 font-semibold" data-id="element-2711" data-mp="2et4evgno1lwn">Privacy Statement</p>
        <p data-id="element-2712" data-mp="2ar9b85i9iwfp">
          By registering with Desert Sage Seminars, you will create an account
          by which we may provide you with quality on-line real estate license
          renewal classes. Your information will be kept confidential and not
          shared with any other party.
        </p>
        <p data-id="element-2713" data-mp="1w1bn1pkc26qi">
          The Arizona Department of Real Estate requires that we confirm your
          information and that you are the person taking the classes.
        </p>
        <p data-id="element-2714" data-mp="3qit1ek375rbm">
          Payments you make for our classes are made through a 3rd party
          merchant account secured by our site, and they do not share your
          credit card information with us or any other party.
        </p>
        <p data-id="element-2715" data-mp="42yjmooov6ek">
          Any requests by an outside party for information about you or your
          account will be denied except for any request from the Arizona
          Department of Real Estate, or any other regulatory agency empowered to
          investigate your real estate activity.
        </p>
        <p data-id="element-2716" data-mp="3ck34b4gdnrn9">
          Any questions or concerns about our Privacy Policy should be sent to{' '}
          <a href="mailto:support@desertsageseminars.com" className="text-blue-600 hover:underline" data-id="element-2717" data-mp="3hh1w3gckjmia">
            support@desertsageseminars.com
          </a>
        </p>
      </div>
  },
  '2': {
    title: 'About Us',
    param: 'about-us',
    text: <div className="text-sm text-slate-800 leading-relaxed" data-id="element-2718" data-mp="10spo9gqp29y3">
        <p className="text-red-600 font-semibold mb-2" data-id="element-2719" data-mp="2xu3lwseszx8f">About Us</p>
        <p data-id="element-2720" data-mp="2xsk7z8gmdy9t">Learn about our history and mission.</p>
      </div>
  },
  '3': {
    title: 'Terms of Service',
    param: 'terms',
    text: <div className="text-sm text-slate-800 leading-relaxed" data-id="element-2721" data-mp="36ujlvrwc8m8j">
        <p className="text-red-600 font-semibold mb-2" data-id="element-2722" data-mp="36spd1bycckkt">Terms of Service</p>
        <p data-id="element-2723" data-mp="31x096wfaghip">Please read these terms carefully.</p>
      </div>
  }
};
export function ViewStaticPage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const page = id && pageData[id] ? pageData[id] : pageData['1'];
  return <div className="space-y-4" data-id="element-2724" data-mp="2nvxkebwwst43">
      <div className="flex items-center justify-between" data-id="element-2725" data-mp="2nw7adzhyf09s">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2726" data-mp="2nxsa03j4l9ei">Static Page</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/static-pages')} data-id="element-2727" data-mp="2j3wct3aorqke">
          ← Back to Static Pages
        </Button>
      </div>

      <Card data-id="element-2728" data-mp="5x7x6zdr3c99">
        <CardContent className="pt-6" data-id="element-2729" data-mp="5weohsv8ecoh">
          <table className="text-sm w-full" data-id="element-2730" data-mp="aphh9ys6pi3m">
            <tbody data-id="element-2731" data-mp="aqiua8srgenz">
              <tr className="border-b border-slate-100" data-id="element-2732" data-mp="ar29hhr10oyb">
                <td className="py-2 pr-6 font-medium text-slate-700 w-20 align-top" data-id="element-2733" data-mp="3t4idv8kmx2bh">
                  Title
                </td>
                <td className="py-2 text-slate-900" data-id="element-2734" data-mp="1ut9a0v85mb4">{page.title}</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2735" data-mp="pn9sieqp7kc0">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2736" data-mp="todbha41lwhg">
                  Text
                </td>
                <td className="py-3 max-w-xl" data-id="element-2737" data-mp="fnsriame5umd">{page.text}</td>
              </tr>
              <tr data-id="element-2738" data-mp="kmcfegkjpghd">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2739" data-mp="klu88owchhuo">
                  Param
                </td>
                <td className="py-2 text-slate-900 font-mono text-xs" data-id="element-2740" data-mp="30gme1uzrquah">
                  {page.param}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6" data-id="element-2741" data-mp="3kouhk13guwuf">
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate(`/static-pages/edit/${id}`)} data-id="element-2742" data-mp="3fwksena6e0t7">
              Edit Page
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}